import React from 'react'

const DialogContext = React.createContext()

const DialogContextProvider = ({children}) => {
  const [dialogs, setDialogs] = React.useState([])

  const popYesNoCancel = React.useCallback(
    ({
      title = '',
      description = '',
      yesLabel = 'Yes',
      yesCallback = (e, close) => {},
      noLabel = 'No',
      noCallback = (e, close) => {},
      cancelLabel = 'Cancel',
    }) => {
      const _dialog = {
        data: {
          title,
          description,
          yesLabel,
          yesCallback,
          noLabel,
          noCallback,
          cancelLabel,
        },
        dialogType: 'yes-no-cancel',
        open: true,
      }
      const _dialogs = [
        ...dialogs.filter(e => e.open === false), // cleanup during addition
        _dialog,
      ]
      setDialogs(_dialogs)
    },
    [setDialogs, dialogs]
  )

  const popAlert = React.useCallback(
    ({title = '', description = '', yesLabel = 'OK', yesCallback = (e, close) => {}}) => {
      const _dialog = {
        data: {
          title,
          description,
          yesLabel,
          yesCallback,
        },
        dialogType: 'alert',
        open: true,
      }
      const _dialogs = [
        ...dialogs.filter(e => e.open === false), // cleanup during addition
        _dialog,
      ]
      setDialogs(_dialogs)
    },
    [setDialogs, dialogs]
  )

  const popYesNo = React.useCallback(
    ({title = '', description = '', yesLabel = 'Yes', yesCallback = (e, close) => {}}) => {
      const _dialog = {
        data: {
          title,
          description,
          yesLabel,
          yesCallback,
        },
        dialogType: 'yes-no',
        open: true,
      }
      const _dialogs = [
        ...dialogs.filter(e => e.open === false), // cleanup during addition
        _dialog,
      ]
      setDialogs(_dialogs)
    },
    [setDialogs, dialogs]
  )

  const handleClose = React.useCallback(
    (event, index) => {
      dialogs[index].open = false
      setDialogs([...dialogs])
    },
    [setDialogs, dialogs]
  )

  const value = {dialogs, popYesNoCancel, popAlert, popYesNo, handleClose}

  return <DialogContext.Provider value={value}>{children}</DialogContext.Provider>
}

const DialogContextConsumer = DialogContext.Consumer

export {DialogContext, DialogContextProvider, DialogContextConsumer}
